import {DefaultInfoV1Props} from "@models/DefaultProps.ts";
import {IEmpresa} from "@models/empresa/IEmpresa.ts";
import {useEmpresa} from "@components/empresas/hooks/useEmpresa.ts";
import {useEffect, useState} from "react";
import {Grid, TextField} from "@mui/material";
import {CpfCnpjInput} from "@shared/custom/CpfCnpjInput.tsx";

interface EmpresaInfoGridProps extends Omit<DefaultInfoV1Props<IEmpresa>, 'variant' | 'EndComponent'> {

}

export function EmpresaInfoGrid(props: EmpresaInfoGridProps) {
    const {getEmpresa} = useEmpresa()
    const [value, setValue] = useState<IEmpresa | undefined>(props.value)

    useEffect(() => {
        if (value == null && props.expectedId) {
            getEmpresa({id: props.expectedId}).then(x => {
                    if (x.items != null) {
                        setValue(x.items)
                    }
                }
            )
        }

    }, [value == null])



    return (value && <Grid container size={12}>
        <Grid size={{xs: 12, sm: 4}}>
            <TextField value={value.id} disabled label={'Id'}/>
        </Grid>
        <Grid size={{xs: 12, sm: 8}}>
            <TextField value={value.nome} label={'Nome'}/>
        </Grid>
        <Grid size={{xs: 12}}>
            <CpfCnpjInput value={value.cnpj}
                          label={'CNPJ'}/>
        </Grid>
    </Grid>)
}